import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
export const useOverviewNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const closeOverview = () => {
    setSearchParams({
      overviewType: null,
      overviewEntityId: null,
      overviewSource: null,
      overviewLanguage: null
    });
  };
  const goTo = ({
    id,
    type,
    language,
    source
  }) => {
    setSearchParams({
      overviewType: type,
      overviewEntityId: id.toString(),
      overviewSource: source !== null && source !== void 0 ? source : searchParams.overviewSource,
      overviewLanguage: language !== null && language !== void 0 ? language : searchParams.overviewLanguage
    });
  };
  return {
    closeOverview,
    goTo
  };
};